export const Element = {
    getOffset(element: Element) {
        const rect = element.getBoundingClientRect()
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY,
            bottom: rect.bottom + window.scrollY,
            right: rect.right + window.scrollX,
        }
    },

    matchMedia(lessThan: boolean, width: number) {
        return window.matchMedia(`(${lessThan ? 'max-' : 'min-'}width: ${width}px)`).matches
    },
}
